// Translations for Local Flyer Delivery App
// Supported languages: English (en), Spanish (es)

export const translations = {
  en: {
    // Common
    app_name: "Local Flyer Delivery",
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    confirm: "Confirm",
    back: "Back",
    next: "Next",
    done: "Done",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    
    // Navigation
    nav_home: "Home",
    nav_history: "History",
    nav_jobs: "Jobs",
    nav_profile: "Profile",
    nav_track: "Track",
    
    // Home Page
    home_greeting: "Hello",
    home_todays_goal: "Today's Delivery Goal",
    home_deliveries_to_go: "deliveries to go",
    home_start_delivering: "Start Delivering",
    home_weekly_activity: "Weekly Activity",
    home_days_worked: "days worked",
    home_total_deliveries: "Total Deliveries",
    home_total_earned: "Total Earned",
    home_total_hours: "Total Hours",
    home_active_job: "Active Job",
    home_find_jobs: "Find Jobs",
    home_no_active_job: "No active job",
    home_browse_jobs: "Browse available jobs",
    home_due_date: "DUE DATE",
    home_overdue: "OVERDUE",
    home_days_left: "days left",
    home_day_left: "day left",
    home_complete: "complete",
    home_earned: "earned",
    home_total: "total",
    
    // Track Page
    track_delivery: "Track Delivery",
    track_distance: "Distance",
    track_duration: "Duration",
    track_points: "Points",
    track_deliveries: "Deliveries",
    track_earned: "Earned",
    track_start_delivering: "START DELIVERING",
    track_finish: "FINISH",
    track_pause: "PAUSE",
    track_resume: "RESUME",
    track_delivery_type: "Delivery Type",
    track_houses: "Houses",
    track_apartments: "Apartments",
    track_cars: "Cars",
    track_hands: "Hands",
    track_per_flyer: "Per Flyer",
    track_hourly: "Hourly",
    track_gps_detection: "GPS Front Door Detection",
    track_gps_detection_desc: "Deliveries credited when GPS shows you at a front door for 6 seconds",
    track_hourly_pay: "Hourly Pay",
    track_hourly_pay_desc: "You will be paid for time worked distributing to",
    track_front_door_active: "Front Door Detection Active",
    track_houses_count: "houses",
    track_delivered: "delivered",
    track_at_front_door: "At Front Door",
    track_stay_seconds: "Stay {seconds}s to confirm delivery",
    track_loading_houses: "Loading house locations...",
    track_fetching_coords: "Fetching front door coordinates",
    track_no_houses: "No Houses Found",
    track_no_houses_desc: "No delivery locations in this zone",
    track_hourly_active: "Hourly Pay Active",
    track_worked: "worked",
    track_delivery_zone: "Delivery Zone",
    track_gps_accuracy: "GPS Accuracy",
    track_no_gps: "No GPS",
    track_excellent_gps: "Excellent GPS",
    track_good_gps: "Good GPS",
    track_fair_gps: "Fair GPS",
    track_poor_gps: "Poor GPS",
    track_complete_session: "Complete Delivery Session?",
    track_great_work: "Great work! Here's your summary:",
    track_session_time: "Session Time",
    track_total_distance: "Total Distance",
    track_flyers_delivered: "Flyers Delivered",
    track_total_earnings: "Total Earnings",
    track_save_complete: "Save & Complete",
    track_continue: "Continue Delivering",
    track_no_active_job: "No Active Job",
    track_accept_job_first: "Accept a job to start tracking deliveries",
    
    // Jobs Page
    jobs_title: "Available Jobs",
    jobs_search: "Search jobs...",
    jobs_no_jobs: "No jobs available",
    jobs_check_back: "Check back soon for new opportunities",
    jobs_flyers: "flyers",
    jobs_deadline: "Deadline",
    jobs_accept: "Accept Job",
    jobs_view_details: "View Details",
    jobs_no_jobs: "No Jobs Available",
    jobs_check_back: "Check back later for new delivery opportunities",
    jobs_view_map: "View Map",
    jobs_close: "Close",
    
    // Home Page - Payout
    home_request_payout: "Request Payout",
    home_payout_no_paypal: "PayPal Not Set Up",
    home_payout_add_paypal: "Please add your PayPal email in Settings to request payouts.",
    home_go_to_settings: "Go to Settings",
    
    // History Page
    history_title: "Delivery History",
    history_no_history: "No delivery history",
    history_start_first: "Complete your first delivery to see it here",
    history_view_route: "View Route",
    
    // Profile Page
    profile_title: "Profile",
    profile_delivering_since: "Delivering since",
    profile_rating: "rating",
    profile_jobs: "Jobs",
    profile_deliveries: "Deliveries",
    profile_hours: "Hours",
    profile_earned: "Earned",
    profile_stats: "stats",
    profile_achievements: "achievements",
    profile_settings: "settings",
    profile_this_week: "This Week",
    profile_all_time: "All-Time Stats",
    profile_total_deliveries: "Total Deliveries",
    profile_avg_per_hour: "Avg/Hour",
    profile_best_streak: "Best Streak",
    profile_current_streak: "Current Streak",
    profile_days: "days",
    profile_badges: "Badges",
    profile_earned_badges: "earned",
    profile_locked: "Locked",
    profile_unlock_pro: "Unlock Pro",
    profile_pro_desc: "Complete 60 jobs or 30,000 flyers to unlock",
    profile_pro_progress: "Progress",
    profile_jobs_remaining: "jobs remaining",
    profile_flyers_remaining: "flyers remaining",
    profile_active: "Active",
    profile_days_worked: "Days Worked",
    
    // Settings
    settings_title: "Settings",
    settings_account: "Account Settings",
    settings_notifications: "Notifications",
    settings_goals: "Goals & Reminders",
    settings_privacy: "Privacy & Safety",
    settings_help: "Help & Support",
    settings_language: "Language",
    settings_contracts: "Contracts",
    settings_logout: "Log Out",
    
    // Contract Settings
    contract_title: "Independent Contractor Agreement",
    contract_status: "Contract Status",
    contract_signed: "Signed",
    contract_not_signed: "Not Signed",
    contract_signed_on: "Signed on",
    contract_review: "Review Contract",
    contract_sign_button: "I Agree & Sign Contract",
    contract_signing: "Signing...",
    contract_sign_success: "Contract signed successfully!",
    contract_required: "Contract Required",
    contract_required_message: "You must sign the Independent Contractor Agreement before you can accept jobs.",
    contract_go_to_settings: "Go to Settings",
    contract_scroll_to_sign: "Scroll to bottom to sign",
    
    // Account Settings
    account_personal_info: "Personal Information",
    account_name: "Name",
    account_email: "Email",
    account_phone: "Phone",
    account_address: "Address",
    account_edit_profile: "Edit Profile",
    account_payment_info: "Payment Information",
    account_paypal_email: "PayPal Email",
    account_payment_note: "Payments are sent to this PayPal account after job approval.",
    account_danger_zone: "Danger Zone",
    account_danger_warning: "These actions are permanent and cannot be undone.",
    account_delete_account: "Delete Account",
    
    // Notifications Settings
    notifications_push: "Push Notifications",
    notifications_enable: "Enable Notifications",
    notifications_enable_desc: "Receive push notifications",
    notifications_alert_types: "Alert Types",
    notifications_new_jobs: "New Jobs Available",
    notifications_new_jobs_desc: "Get notified when new jobs match your area",
    notifications_job_reminders: "Job Reminders",
    notifications_job_reminders_desc: "Reminders for active job deadlines",
    notifications_payment_alerts: "Payment Alerts",
    notifications_payment_alerts_desc: "Get notified when you receive payment",
    notifications_weekly_summary: "Weekly Summary",
    notifications_weekly_summary_desc: "Weekly earnings and stats report",
    notifications_promotions: "Promotions & Tips",
    notifications_promotions_desc: "Bonus opportunities and delivery tips",
    
    // Goals Settings
    goals_daily: "Daily Goals",
    goals_daily_delivery: "Daily Delivery Goal",
    goals_deliveries_per_day: "deliveries per day",
    goals_weekly: "Weekly Goals",
    goals_weekly_earnings: "Weekly Earnings Goal",
    goals_per_week: "per week",
    goals_weekly_jobs: "Weekly Jobs Goal",
    goals_jobs_per_week: "jobs per week",
    goals_daily_reminder: "Daily Reminder",
    goals_enable_reminder: "Enable Daily Reminder",
    goals_reminder_desc: "Get reminded to start delivering",
    goals_reminder_time: "Reminder Time",
    goals_save: "Save Goals",
    
    // Privacy Settings
    privacy_visibility: "Profile Visibility",
    privacy_show_profile: "Show Profile to Others",
    privacy_show_profile_desc: "Allow other users to see your profile",
    privacy_show_earnings: "Show Earnings",
    privacy_show_earnings_desc: "Display your earnings on leaderboards",
    privacy_show_stats: "Show Stats",
    privacy_show_stats_desc: "Display delivery stats publicly",
    privacy_data_tracking: "Data & Tracking",
    privacy_location: "Location Tracking",
    privacy_location_desc: "Required for delivery verification",
    privacy_analytics: "Analytics Data Sharing",
    privacy_analytics_desc: "Help improve app with usage data",
    privacy_security: "Security",
    privacy_change_password: "Change Password",
    privacy_two_factor: "Two-Factor Authentication",
    
    // Help Settings
    help_quick: "Quick Help",
    help_faqs: "FAQs",
    help_contact: "Contact Support",
    help_tutorials: "Video Tutorials",
    help_common_questions: "Common Questions",
    help_how_paid: "How do I get paid?",
    help_how_paid_answer: "Payments are processed via PayPal within 24-48 hours after job approval.",
    help_verification: "How does delivery verification work?",
    help_verification_answer: "GPS detects when you stop at a front door for 6 seconds to automatically credit the delivery.",
    help_multiple_jobs: "Can I have multiple active jobs?",
    help_multiple_jobs_answer: "No, you can only have one active job at a time to ensure quality deliveries.",
    help_legal: "Legal",
    help_terms: "Terms of Service",
    help_privacy_policy: "Privacy Policy",
    help_contractor: "Independent Contractor Agreement",
    help_app_version: "App Version",
    
    // Language Settings
    language_title: "Language",
    language_select: "Select Language",
    language_english: "English",
    language_spanish: "Spanish",
    language_current: "Current",
    
    // Days of week
    day_mon: "Mon",
    day_tue: "Tue",
    day_wed: "Wed",
    day_thu: "Thu",
    day_fri: "Fri",
    day_sat: "Sat",
    day_sun: "Sun",
    
    // Achievements
    achievement_first_delivery: "First Delivery",
    achievement_1000_flyers: "1000 Flyers",
    achievement_7_day_streak: "7 Day Streak",
    achievement_30_day_streak: "30 Day Streak",
    achievement_1000_earned: "$1000 Earned",
    achievement_early_bird: "Early Bird",
    
    // Toasts/Alerts
    toast_profile_updated: "Profile updated successfully",
    toast_goals_saved: "Goals saved successfully",
    toast_logged_out: "Logged out successfully",
    toast_delivery_credited: "delivered!",
    toast_gps_confirmed: "GPS confirmed: You stopped at the front door",
    toast_houses_loaded: "house locations for auto-detection",
    toast_houses_found: "Found {count} delivery points",
    toast_no_houses: "No house data available in this zone. You can still track deliveries manually.",
    toast_houses_error: "Could not load house locations",
    toast_houses_timeout: "House data loading timed out. You can still track deliveries manually.",
    
    // Auth Pages
    auth_welcome_back: "Welcome Back",
    auth_admin_login: "Admin Login",
    auth_access_dashboard: "Access the admin dashboard",
    auth_sign_in_account: "Sign in to your account",
    auth_email_address: "Email Address",
    auth_password: "Password",
    auth_sign_in: "Sign In",
    auth_signing_in: "Signing In...",
    auth_no_account: "Don't have an account?",
    auth_sign_up: "Sign Up",
    auth_back_to_app: "Back to App",
    auth_create_account: "Create Account",
    auth_join: "Join Local Flyer Delivery",
    auth_full_name: "Full Name",
    auth_paypal_email: "PayPal Email",
    auth_paypal_note: "Payments will be sent to this PayPal account",
    auth_phone: "Phone Number",
    auth_address: "Address",
    auth_ssn_ein: "SSN or EIN",
    auth_ssn_note: "Required for tax purposes (1099 reporting)",
    auth_confirm_password: "Confirm Password",
    auth_agree_terms: "I agree to the",
    auth_terms_of_service: "Terms of Service",
    auth_and: "and",
    auth_privacy_policy: "Privacy Policy",
    auth_contractor_acknowledge: "I understand and acknowledge that I am an",
    auth_independent_contractor: "independent contractor",
    auth_not_employee: "and not an employee",
    auth_creating_account: "Creating Account...",
    auth_already_have_account: "Already have an account?",
    auth_login_success: "Login successful!",
    auth_login_failed: "Login failed",
    auth_register_success: "Registration successful! Your account is pending approval.",
    auth_register_failed: "Registration failed",
    auth_passwords_not_match: "Passwords do not match",
    auth_agree_terms_required: "You must agree to the Terms of Service",
    auth_contractor_required: "You must acknowledge independent contractor status",
    
    // Job Search Page
    jobs_find: "Find Jobs",
    jobs_search_placeholder: "Search jobs, clients, areas...",
    jobs_filter_all: "All Jobs",
    jobs_filter_nearby: "Nearby",
    jobs_filter_highpay: "High Pay",
    jobs_filter_easy: "Easy",
    jobs_filter_urgent: "Urgent",
    jobs_featured: "Featured",
    jobs_post_availability: "Post Your Availability",
    jobs_post_availability_desc: "Let clients know when you're available to deliver",
    jobs_total_pay: "Total Pay",
    
    // History Page
    history_search_placeholder: "Search jobs...",
    history_filter_all: "All",
    history_filter_week: "This Week",
    history_filter_month: "This Month",
    history_filter_completed: "Completed",
    history_total_summary: "Total Summary",
    history_deliveries: "Deliveries",
    history_earned: "Earned",
    history_miles: "Miles",
    history_recent_jobs: "Recent Jobs",
    history_completed: "Completed",
    history_flyers: "Flyers",
    history_duration: "Duration",
    history_start: "Start",
    history_end: "End",
    history_tap_to_expand: "Tap to expand",
    history_no_route: "No GPS route recorded for this session",
    history_route: "Route",
    history_paid: "Paid",
    history_approved: "Approved",
    history_pending: "Pending",
    
    // Payout Modal
    track_job_completed: "Job Completed!",
    payout_request: "Request Payout",
    payout_skip: "Skip for Now",
    payout_no_paypal: "No PayPal Connected",
    payout_add_paypal_message: "Add your PayPal email in Profile to receive payments.",
    payout_add_paypal_first: "Please add your PayPal email in your profile first",
    payout_requested: "Payout request submitted! You will be paid once an admin approves your delivery.",
    
    // Photo Upload
    photo_upload_title: "Upload Delivery Photos",
    photo_upload_desc: "Upload 10 photos of flyers on doors for client reporting",
    photo_upload_btn: "Upload Photos",
    photo_upload_error: "Failed to upload photo",
    photos_complete: "All required photos uploaded!",
    photos_required: "Please upload 10 photos of flyers on doors before requesting payout",
    uploading: "Uploading...",
    toast_houses_generated: "Generated delivery points for this zone",
  },
  
  es: {
    // Common
    app_name: "Entrega de Volantes Local",
    save: "Guardar",
    cancel: "Cancelar",
    edit: "Editar",
    delete: "Eliminar",
    confirm: "Confirmar",
    back: "Atrás",
    next: "Siguiente",
    done: "Hecho",
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    
    // Navigation
    nav_home: "Inicio",
    nav_history: "Historial",
    nav_jobs: "Trabajos",
    nav_profile: "Perfil",
    nav_track: "Rastrear",
    
    // Home Page
    home_greeting: "Hola",
    home_todays_goal: "Meta de Entregas de Hoy",
    home_deliveries_to_go: "entregas por hacer",
    home_start_delivering: "Comenzar a Entregar",
    home_weekly_activity: "Actividad Semanal",
    home_days_worked: "días trabajados",
    home_total_deliveries: "Entregas Totales",
    home_total_earned: "Total Ganado",
    home_total_hours: "Horas Totales",
    home_active_job: "Trabajo Activo",
    home_find_jobs: "Buscar Trabajos",
    home_no_active_job: "Sin trabajo activo",
    home_browse_jobs: "Explorar trabajos disponibles",
    home_due_date: "FECHA LÍMITE",
    home_overdue: "VENCIDO",
    home_days_left: "días restantes",
    home_day_left: "día restante",
    home_complete: "completado",
    home_earned: "ganado",
    home_total: "total",
    
    // Track Page
    track_delivery: "Rastrear Entrega",
    track_distance: "Distancia",
    track_duration: "Duración",
    track_points: "Puntos",
    track_deliveries: "Entregas",
    track_earned: "Ganado",
    track_start_delivering: "COMENZAR ENTREGAS",
    track_finish: "TERMINAR",
    track_pause: "PAUSAR",
    track_resume: "REANUDAR",
    track_delivery_type: "Tipo de Entrega",
    track_houses: "Casas",
    track_apartments: "Apartamentos",
    track_cars: "Autos",
    track_hands: "Manos",
    track_per_flyer: "Por Volante",
    track_hourly: "Por Hora",
    track_gps_detection: "Detección GPS de Puerta",
    track_gps_detection_desc: "Las entregas se acreditan cuando el GPS muestra que estás en la puerta por 6 segundos",
    track_hourly_pay: "Pago por Hora",
    track_hourly_pay_desc: "Se te pagará por el tiempo trabajado distribuyendo a",
    track_front_door_active: "Detección de Puerta Activa",
    track_houses_count: "casas",
    track_delivered: "entregadas",
    track_at_front_door: "En la Puerta",
    track_stay_seconds: "Quédate {seconds}s para confirmar entrega",
    track_loading_houses: "Cargando ubicaciones de casas...",
    track_fetching_coords: "Obteniendo coordenadas de puertas",
    track_no_houses: "No Se Encontraron Casas",
    track_no_houses_desc: "No hay ubicaciones de entrega en esta zona",
    track_hourly_active: "Pago por Hora Activo",
    track_worked: "trabajado",
    track_delivery_zone: "Zona de Entrega",
    track_gps_accuracy: "Precisión GPS",
    track_no_gps: "Sin GPS",
    track_excellent_gps: "GPS Excelente",
    track_good_gps: "GPS Bueno",
    track_fair_gps: "GPS Regular",
    track_poor_gps: "GPS Débil",
    track_complete_session: "¿Completar Sesión de Entrega?",
    track_great_work: "¡Excelente trabajo! Aquí está tu resumen:",
    track_session_time: "Tiempo de Sesión",
    track_total_distance: "Distancia Total",
    track_flyers_delivered: "Volantes Entregados",
    track_total_earnings: "Ganancias Totales",
    track_save_complete: "Guardar y Completar",
    track_continue: "Continuar Entregando",
    track_no_active_job: "Sin Trabajo Activo",
    track_accept_job_first: "Acepta un trabajo para comenzar a rastrear entregas",
    
    // Jobs Page
    jobs_title: "Trabajos Disponibles",
    jobs_search: "Buscar trabajos...",
    jobs_no_jobs: "No hay trabajos disponibles",
    jobs_check_back: "Vuelve pronto para nuevas oportunidades",
    jobs_flyers: "volantes",
    jobs_deadline: "Fecha límite",
    jobs_accept: "Aceptar Trabajo",
    jobs_view_details: "Ver Detalles",
    jobs_view_map: "Ver Mapa",
    jobs_close: "Cerrar",
    
    // Home Page - Payout
    home_request_payout: "Solicitar Pago",
    home_payout_no_paypal: "PayPal No Configurado",
    home_payout_add_paypal: "Por favor agrega tu correo de PayPal en Ajustes para solicitar pagos.",
    home_go_to_settings: "Ir a Ajustes",
    
    // History Page
    history_title: "Historial de Entregas",
    history_no_history: "Sin historial de entregas",
    history_start_first: "Completa tu primera entrega para verla aquí",
    history_view_route: "Ver Ruta",
    
    // Profile Page
    profile_title: "Perfil",
    profile_delivering_since: "Entregando desde",
    profile_rating: "calificación",
    profile_jobs: "Trabajos",
    profile_deliveries: "Entregas",
    profile_hours: "Horas",
    profile_earned: "Ganado",
    profile_stats: "estadísticas",
    profile_achievements: "logros",
    profile_settings: "ajustes",
    profile_this_week: "Esta Semana",
    profile_all_time: "Estadísticas Totales",
    profile_total_deliveries: "Entregas Totales",
    profile_avg_per_hour: "Promedio/Hora",
    profile_best_streak: "Mejor Racha",
    profile_current_streak: "Racha Actual",
    profile_days: "días",
    profile_badges: "Insignias",
    profile_earned_badges: "ganadas",
    profile_locked: "Bloqueado",
    profile_unlock_pro: "Desbloquear Pro",
    profile_pro_desc: "Completa 60 trabajos o 30,000 volantes para desbloquear",
    profile_pro_progress: "Progreso",
    profile_jobs_remaining: "trabajos restantes",
    profile_flyers_remaining: "volantes restantes",
    profile_active: "Activo",
    profile_days_worked: "Días Trabajados",
    
    // Settings
    settings_title: "Ajustes",
    settings_account: "Ajustes de Cuenta",
    settings_notifications: "Notificaciones",
    settings_goals: "Metas y Recordatorios",
    settings_privacy: "Privacidad y Seguridad",
    settings_help: "Ayuda y Soporte",
    settings_language: "Idioma",
    settings_contracts: "Contratos",
    settings_logout: "Cerrar Sesión",
    
    // Contract Settings
    contract_title: "Acuerdo de Contratista Independiente",
    contract_status: "Estado del Contrato",
    contract_signed: "Firmado",
    contract_not_signed: "No Firmado",
    contract_signed_on: "Firmado el",
    contract_review: "Revisar Contrato",
    contract_sign_button: "Acepto y Firmo el Contrato",
    contract_signing: "Firmando...",
    contract_sign_success: "¡Contrato firmado exitosamente!",
    contract_required: "Contrato Requerido",
    contract_required_message: "Debes firmar el Acuerdo de Contratista Independiente antes de poder aceptar trabajos.",
    contract_go_to_settings: "Ir a Ajustes",
    contract_scroll_to_sign: "Desplázate hacia abajo para firmar",
    
    // Account Settings
    account_personal_info: "Información Personal",
    account_name: "Nombre",
    account_email: "Correo Electrónico",
    account_phone: "Teléfono",
    account_address: "Dirección",
    account_edit_profile: "Editar Perfil",
    account_payment_info: "Información de Pago",
    account_paypal_email: "Correo de PayPal",
    account_payment_note: "Los pagos se envían a esta cuenta de PayPal después de la aprobación del trabajo.",
    account_danger_zone: "Zona de Peligro",
    account_danger_warning: "Estas acciones son permanentes y no se pueden deshacer.",
    account_delete_account: "Eliminar Cuenta",
    
    // Notifications Settings
    notifications_push: "Notificaciones Push",
    notifications_enable: "Activar Notificaciones",
    notifications_enable_desc: "Recibir notificaciones push",
    notifications_alert_types: "Tipos de Alertas",
    notifications_new_jobs: "Nuevos Trabajos Disponibles",
    notifications_new_jobs_desc: "Recibe alertas cuando haya nuevos trabajos en tu área",
    notifications_job_reminders: "Recordatorios de Trabajo",
    notifications_job_reminders_desc: "Recordatorios de fechas límite de trabajos activos",
    notifications_payment_alerts: "Alertas de Pago",
    notifications_payment_alerts_desc: "Recibe alertas cuando recibas un pago",
    notifications_weekly_summary: "Resumen Semanal",
    notifications_weekly_summary_desc: "Reporte semanal de ganancias y estadísticas",
    notifications_promotions: "Promociones y Consejos",
    notifications_promotions_desc: "Oportunidades de bonos y consejos de entrega",
    
    // Goals Settings
    goals_daily: "Metas Diarias",
    goals_daily_delivery: "Meta de Entregas Diarias",
    goals_deliveries_per_day: "entregas por día",
    goals_weekly: "Metas Semanales",
    goals_weekly_earnings: "Meta de Ganancias Semanales",
    goals_per_week: "por semana",
    goals_weekly_jobs: "Meta de Trabajos Semanales",
    goals_jobs_per_week: "trabajos por semana",
    goals_daily_reminder: "Recordatorio Diario",
    goals_enable_reminder: "Activar Recordatorio Diario",
    goals_reminder_desc: "Recibe un recordatorio para comenzar a entregar",
    goals_reminder_time: "Hora del Recordatorio",
    goals_save: "Guardar Metas",
    
    // Privacy Settings
    privacy_visibility: "Visibilidad del Perfil",
    privacy_show_profile: "Mostrar Perfil a Otros",
    privacy_show_profile_desc: "Permitir que otros usuarios vean tu perfil",
    privacy_show_earnings: "Mostrar Ganancias",
    privacy_show_earnings_desc: "Mostrar tus ganancias en tablas de clasificación",
    privacy_show_stats: "Mostrar Estadísticas",
    privacy_show_stats_desc: "Mostrar estadísticas de entrega públicamente",
    privacy_data_tracking: "Datos y Rastreo",
    privacy_location: "Rastreo de Ubicación",
    privacy_location_desc: "Requerido para verificación de entregas",
    privacy_analytics: "Compartir Datos de Análisis",
    privacy_analytics_desc: "Ayuda a mejorar la app con datos de uso",
    privacy_security: "Seguridad",
    privacy_change_password: "Cambiar Contraseña",
    privacy_two_factor: "Autenticación de Dos Factores",
    
    // Help Settings
    help_quick: "Ayuda Rápida",
    help_faqs: "Preguntas Frecuentes",
    help_contact: "Contactar Soporte",
    help_tutorials: "Videos Tutoriales",
    help_common_questions: "Preguntas Comunes",
    help_how_paid: "¿Cómo me pagan?",
    help_how_paid_answer: "Los pagos se procesan vía PayPal dentro de 24-48 horas después de la aprobación del trabajo.",
    help_verification: "¿Cómo funciona la verificación de entrega?",
    help_verification_answer: "El GPS detecta cuando te detienes en una puerta por 6 segundos para acreditar automáticamente la entrega.",
    help_multiple_jobs: "¿Puedo tener múltiples trabajos activos?",
    help_multiple_jobs_answer: "No, solo puedes tener un trabajo activo a la vez para asegurar entregas de calidad.",
    help_legal: "Legal",
    help_terms: "Términos de Servicio",
    help_privacy_policy: "Política de Privacidad",
    help_contractor: "Acuerdo de Contratista Independiente",
    help_app_version: "Versión de la App",
    
    // Language Settings
    language_title: "Idioma",
    language_select: "Seleccionar Idioma",
    language_english: "Inglés",
    language_spanish: "Español",
    language_current: "Actual",
    
    // Days of week
    day_mon: "Lun",
    day_tue: "Mar",
    day_wed: "Mié",
    day_thu: "Jue",
    day_fri: "Vie",
    day_sat: "Sáb",
    day_sun: "Dom",
    
    // Achievements
    achievement_first_delivery: "Primera Entrega",
    achievement_1000_flyers: "1000 Volantes",
    achievement_7_day_streak: "Racha de 7 Días",
    achievement_30_day_streak: "Racha de 30 Días",
    achievement_1000_earned: "$1000 Ganados",
    achievement_early_bird: "Madrugador",
    
    // Toasts/Alerts
    toast_profile_updated: "Perfil actualizado exitosamente",
    toast_goals_saved: "Metas guardadas exitosamente",
    toast_logged_out: "Sesión cerrada exitosamente",
    toast_delivery_credited: "¡entregado!",
    toast_gps_confirmed: "GPS confirmado: Te detuviste en la puerta",
    toast_houses_loaded: "ubicaciones de casas para auto-detección",
    toast_houses_found: "Se encontraron {count} puntos de entrega",
    toast_no_houses: "No hay datos de casas disponibles en esta zona. Aún puedes rastrear entregas manualmente.",
    toast_houses_error: "No se pudieron cargar las ubicaciones de casas",
    toast_houses_timeout: "La carga de datos de casas expiró. Aún puedes rastrear entregas manualmente.",
    
    // Auth Pages
    auth_welcome_back: "Bienvenido",
    auth_admin_login: "Inicio de Sesión Admin",
    auth_access_dashboard: "Acceder al panel de administración",
    auth_sign_in_account: "Inicia sesión en tu cuenta",
    auth_email_address: "Correo Electrónico",
    auth_password: "Contraseña",
    auth_sign_in: "Iniciar Sesión",
    auth_signing_in: "Iniciando Sesión...",
    auth_no_account: "¿No tienes una cuenta?",
    auth_sign_up: "Regístrate",
    auth_back_to_app: "Volver a la App",
    auth_create_account: "Crear Cuenta",
    auth_join: "Únete a Entrega de Volantes Local",
    auth_full_name: "Nombre Completo",
    auth_paypal_email: "Correo de PayPal",
    auth_paypal_note: "Los pagos se enviarán a esta cuenta de PayPal",
    auth_phone: "Número de Teléfono",
    auth_address: "Dirección",
    auth_ssn_ein: "SSN o EIN",
    auth_ssn_note: "Requerido para propósitos fiscales (reporte 1099)",
    auth_confirm_password: "Confirmar Contraseña",
    auth_agree_terms: "Acepto los",
    auth_terms_of_service: "Términos de Servicio",
    auth_and: "y",
    auth_privacy_policy: "Política de Privacidad",
    auth_contractor_acknowledge: "Entiendo y reconozco que soy un",
    auth_independent_contractor: "contratista independiente",
    auth_not_employee: "y no un empleado",
    auth_creating_account: "Creando Cuenta...",
    auth_already_have_account: "¿Ya tienes una cuenta?",
    auth_login_success: "¡Inicio de sesión exitoso!",
    auth_login_failed: "Error al iniciar sesión",
    auth_register_success: "¡Registro exitoso! Tu cuenta está pendiente de aprobación.",
    auth_register_failed: "Error en el registro",
    auth_passwords_not_match: "Las contraseñas no coinciden",
    auth_agree_terms_required: "Debes aceptar los Términos de Servicio",
    auth_contractor_required: "Debes reconocer el estado de contratista independiente",
    
    // Job Search Page
    jobs_find: "Buscar Trabajos",
    jobs_search_placeholder: "Buscar trabajos, clientes, áreas...",
    jobs_filter_all: "Todos",
    jobs_filter_nearby: "Cercanos",
    jobs_filter_highpay: "Mejor Pago",
    jobs_filter_easy: "Fácil",
    jobs_filter_urgent: "Urgente",
    jobs_featured: "Destacado",
    jobs_post_availability: "Publica tu Disponibilidad",
    jobs_post_availability_desc: "Deja que los clientes sepan cuándo estás disponible para entregar",
    jobs_total_pay: "Pago Total",
    
    // History Page
    history_search_placeholder: "Buscar trabajos...",
    history_filter_all: "Todos",
    history_filter_week: "Esta Semana",
    history_filter_month: "Este Mes",
    history_filter_completed: "Completados",
    history_total_summary: "Resumen Total",
    history_deliveries: "Entregas",
    history_earned: "Ganado",
    history_miles: "Millas",
    history_recent_jobs: "Trabajos Recientes",
    history_completed: "Completado",
    history_flyers: "Volantes",
    history_duration: "Duración",
    history_start: "Inicio",
    history_end: "Fin",
    history_tap_to_expand: "Toca para expandir",
    history_no_route: "No hay ruta GPS registrada para esta sesión",
    history_route: "Ruta",
    history_paid: "Pagado",
    history_approved: "Aprobado",
    history_pending: "Pendiente",
    
    // Payout Modal
    track_job_completed: "¡Trabajo Completado!",
    payout_request: "Solicitar Pago",
    payout_skip: "Omitir por Ahora",
    payout_no_paypal: "PayPal No Conectado",
    payout_add_paypal_message: "Agrega tu correo de PayPal en Perfil para recibir pagos.",
    payout_add_paypal_first: "Por favor agrega tu correo de PayPal en tu perfil primero",
    payout_requested: "¡Solicitud de pago enviada! Se te pagará una vez que un administrador apruebe tu entrega.",
    
    // Photo Upload
    photo_upload_title: "Subir Fotos de Entrega",
    photo_upload_desc: "Sube 10 fotos de volantes en puertas para reporte del cliente",
    photo_upload_btn: "Subir Fotos",
    photo_upload_error: "Error al subir foto",
    photos_complete: "¡Todas las fotos requeridas subidas!",
    photos_required: "Por favor sube 10 fotos de volantes en puertas antes de solicitar pago",
    uploading: "Subiendo...",
    toast_houses_generated: "Puntos de entrega generados para esta zona",
  }
};

export const supportedLanguages = [
  { code: 'en', name: 'English', nativeName: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Spanish', nativeName: 'Español', flag: '🇪🇸' },
];

export default translations;
